import { IBroadcastFormReportGroup } from 'types/BroadcastForm'

const buildProfileIdSet = (
  groups: IBroadcastFormReportGroup[],
  selectedIds: number[],
): Set<number> => {
  const selectedIdSet = new Set(selectedIds)
  const profileIdSet = new Set<number>()

  for (let i = 0; i < groups.length; i += 1) {
    const group = groups[i]
    if (selectedIdSet.has(group.GroupId)) {
      const { ProfileIds } = group
      for (let j = 0; j < ProfileIds.length; j += 1) {
        profileIdSet.add(ProfileIds[j])
      }
    }
  }

  return profileIdSet
}

/**
 * Apply Groups include + Group Exclusion filters.
 * Exclusion uses union semantics: a recipient is excluded if they belong
 * to ANY selected excluded group.
 */
export const applyEnterpriseSurveyGroupFilters = <T extends { ProfileId: number }>(
  rows: T[],
  groups: IBroadcastFormReportGroup[] | null | undefined,
  groupIds: number[],
  excludedGroupIds: number[],
): T[] => {
  let result = rows

  if (groupIds.length > 0 && groups) {
    const profileIdSet = buildProfileIdSet(groups, groupIds)
    result = profileIdSet.size > 0
      ? result.filter((row) => profileIdSet.has(row.ProfileId))
      : []
  }

  if (excludedGroupIds.length > 0 && groups) {
    const excludedProfileIdSet = buildProfileIdSet(groups, excludedGroupIds)
    if (excludedProfileIdSet.size > 0) {
      result = result.filter((row) => !excludedProfileIdSet.has(row.ProfileId))
    }
  }

  return result
}
